/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberShiftIdQueryResponse, GetApiBarberShiftIdPathParams, GetApiBarberShiftId400, GetApiBarberShiftId401, GetApiBarberShiftId403, GetApiBarberShiftId404, GetApiBarberShiftId500 } from "../entities/GetApiBarberShiftId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBarberShiftId } from "../api/getApiBarberShiftId";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBarberShiftIdQueryKey = (id: GetApiBarberShiftIdPathParams["id"] | undefined) => [{ url: '/api/barber/shift/:id', params: {id:id} }] as const

export type GetApiBarberShiftIdQueryKey = ReturnType<typeof getApiBarberShiftIdQueryKey>

export function getApiBarberShiftIdQueryOptions(id: GetApiBarberShiftIdPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBarberShiftIdQueryKey(id)
        return queryOptions<GetApiBarberShiftIdQueryResponse, ResponseErrorConfig<GetApiBarberShiftId400 | GetApiBarberShiftId401 | GetApiBarberShiftId403 | GetApiBarberShiftId404 | GetApiBarberShiftId500>, GetApiBarberShiftIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBarberShiftId(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить детали смены мастера
 * @summary Получить смену
 * {@link /api/barber/shift/:id}
 */
export function useGetApiBarberShiftId<TData = GetApiBarberShiftIdQueryResponse, TQueryData = GetApiBarberShiftIdQueryResponse, TQueryKey extends QueryKey = GetApiBarberShiftIdQueryKey>(id: GetApiBarberShiftIdPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBarberShiftIdQueryResponse, ResponseErrorConfig<GetApiBarberShiftId400 | GetApiBarberShiftId401 | GetApiBarberShiftId403 | GetApiBarberShiftId404 | GetApiBarberShiftId500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBarberShiftIdQueryKey(id)
         

         const query = useQuery({
          ...getApiBarberShiftIdQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiBarberShiftId400 | GetApiBarberShiftId401 | GetApiBarberShiftId403 | GetApiBarberShiftId404 | GetApiBarberShiftId500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}